<div class="change-password-card">
  <button
    type="button"
    class="card-toggle"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="isExpanded()"
  >
    <div class="toggle-left">
      <app-icon [type]="IconType.LOCK" [size]="20"></app-icon>
      <span class="toggle-title">Passwort ändern</span>
    </div>
    <app-icon
      [type]="IconType.CHEVRON_DOWN"
      [size]="20"
      [class.rotated]="isExpanded()"
    ></app-icon>
  </button>

  @if (isExpanded()) {
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="password-form">
      <div class="form-group">
        <label for="currentPassword" class="form-label">Aktuelles Passwort</label>
        <div class="password-input-wrapper">
          <input
            [type]="showCurrentPassword() ? 'text' : 'password'"
            id="currentPassword"
            formControlName="currentPassword"
            class="form-input"
            placeholder="Aktuelles Passwort eingeben"
          />
          <button
            type="button"
            class="password-toggle"
            (click)="togglePasswordVisibility('current')"
            [attr.aria-label]="showCurrentPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
            [attr.aria-pressed]="showCurrentPassword()"
          >
            <app-icon
              [type]="showCurrentPassword() ? IconType.EYE_OFF : IconType.EYE"
              [size]="18"
            ></app-icon>
          </button>
        </div>
        @if (hasError('currentPassword', 'required')) {
          <span class="error-text">Aktuelles Passwort ist erforderlich</span>
        }
      </div>

      <div class="form-group">
        <label for="newPassword" class="form-label">Neues Passwort</label>
        <div class="password-input-wrapper">
          <input
            [type]="showNewPassword() ? 'text' : 'password'"
            id="newPassword"
            formControlName="newPassword"
            class="form-input"
            placeholder="Neues Passwort eingeben"
          />
          <button
            type="button"
            class="password-toggle"
            (click)="togglePasswordVisibility('new')"
            [attr.aria-label]="showNewPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
            [attr.aria-pressed]="showNewPassword()"
          >
            <app-icon
              [type]="showNewPassword() ? IconType.EYE_OFF : IconType.EYE"
              [size]="18"
            ></app-icon>
          </button>
        </div>
        @if (hasError('newPassword', 'required')) {
          <span class="error-text">Neues Passwort ist erforderlich</span>
        }
        @if (hasError('newPassword', 'minlength')) {
          <span class="error-text">Mindestens 8 Zeichen erforderlich</span>
        }
        @if (passwordForm.hasError('samePassword') && passwordForm.get('newPassword')?.touched) {
          <span class="error-text">Neues Passwort muss sich vom aktuellen unterscheiden</span>
        }
      </div>

      <div class="form-group">
        <label for="confirmPassword" class="form-label">Passwort bestätigen</label>
        <div class="password-input-wrapper">
          <input
            [type]="showConfirmPassword() ? 'text' : 'password'"
            id="confirmPassword"
            formControlName="confirmPassword"
            class="form-input"
            placeholder="Neues Passwort bestätigen"
          />
          <button
            type="button"
            class="password-toggle"
            (click)="togglePasswordVisibility('confirm')"
            [attr.aria-label]="showConfirmPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
            [attr.aria-pressed]="showConfirmPassword()"
          >
            <app-icon
              [type]="showConfirmPassword() ? IconType.EYE_OFF : IconType.EYE"
              [size]="18"
            ></app-icon>
          </button>
        </div>
        @if (hasError('confirmPassword', 'required')) {
          <span class="error-text">Passwortbestätigung ist erforderlich</span>
        }
        @if (passwordForm.hasError('passwordMismatch') && passwordForm.get('confirmPassword')?.touched) {
          <span class="error-text">Passwörter stimmen nicht überein</span>
        }
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="toggleExpanded()"
          [disabled]="isSaving()"
        >
          Abbrechen
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!passwordForm.valid || isSaving()"
          [class.btn-loading]="isSaving()"
        >
          @if (isSaving()) {
            Speichern...
          } @else {
            Passwort ändern
          }
        </button>
      </div>
    </form>
  }
</div>
